import { jobLists } from "character";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import { quests } from "data-files/quests";
import { shops } from "data-files/shops";
import { EorzeaDataType, GameData, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewToolSkysteelBaseProps } from "views/relics/tools/skysteel/base-tool/types";
import "./ToolSkysteelBase.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class ToolSkysteelBase extends Component<ViewToolSkysteelBaseProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.TOOL_SKYSTEEL],
		type: RelicData.Type.TOOL,
		relic: RelicData.Group.TOOL_SKYSTEEL,
		part: RelicData.Part.TOOL_SKYSTEEL,
		steps: [RelicData.Step.PURCHASE],
		stepPlaceholders: {},
		next: {
			part: RelicData.Part.TOOL_SKYSTEEL_1,
			view: View.RELIC_TOOLS_SKYSTEEL_SKYSTEEL_1,
		},
		previous: null,
	};

	constructor(props:ViewToolSkysteelBaseProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		return (
			<div id="tool-skysteel-base" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
					<p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.BLUEQUEST} text={GameData.Quest.MISLAID_PLANS} lodestoneID={quests[GameData.Quest.MISLAID_PLANS].lodestoneID} /></p>
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.PURCHASE} id={RelicData.Step.PURCHASE} stepComplete={completeSteps[RelicData.Step.PURCHASE]}>
						<p>{t.t("After completing %QUEST% - The rest of the base tools can be purchased from %SHOP% for 80,000 %CURRENCY% each (800,000 total for all tools)", { QUEST: GameData.Quest.MISLAID_PLANS, SHOP: GameData.Shop.DENYS, CURRENCY: GameData.Currency.GIL })}</p>
						<p><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.SHOP} lodestoneID={shops[GameData.Shop.DENYS].lodestoneID} text={GameData.Shop.DENYS} /></p>
					</DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		return [
			{ type: quests[GameData.Quest.TOWARDS_THE_FIRMAMENT].type, text: GameData.Quest.TOWARDS_THE_FIRMAMENT, lodestoneID: quests[GameData.Quest.TOWARDS_THE_FIRMAMENT].lodestoneID },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [GameData.NPC.SKYSTEEL_ENGINEER, GameData.NPC.DENYS];
	}
}
export default connect(mapStateToProps)(ToolSkysteelBase);
